export default (state = [], action) => {
  const safeState = Array.isArray(state) ? state : []
  let { type, payload } = action
  switch (type) {
    case 'SUBSCRIPTION_PLANS_SET':
      return Array.isArray(payload) ? payload : safeState
    default:
      return safeState
  }
}
